import { queryOptions } from '@tanstack/react-query';
import { z } from 'zod';
import { apiClient } from '@/api/axios';
import { API } from '@/api/endpoints';
import { STALE_TIME } from '@/api/staleTimes';

export const permissionsSchema = z.object({
  isAdmin: z.boolean(),
  permissions: z.array(z.string()),
});

export type Permissions = z.infer<typeof permissionsSchema>;

export const permissionsQueryKeys = {
  all: () => ['auth', 'permissions'] as const,
};

export const permissionsQueryOptions = () =>
  queryOptions({
    queryKey: permissionsQueryKeys.all(),
    queryFn: async (): Promise<Permissions> => {
      const res = await apiClient.get(API.auth.permissions);
      return permissionsSchema.parse(res.data);
    },
    staleTime: STALE_TIME,
  });
